import { automaticGraphics, graphicsProfile, storeGraphics, storedGraphics, type GraphicsQuality } from '../render3d/quality';

const QUALITY_LABEL: Record<GraphicsQuality, string> = { low: 'Low', balanced: 'Balanced', high: 'High' };

/** Profiles are compiled at startup, so changing the selection reloads the page. */
export function GraphicsSetting() {
  const stored = storedGraphics();
  const fromAddress = new URLSearchParams(location.search).has('graphics');
  return <>
    <div className="section-label">Graphics</div>
    <label className="row">
      <span className="grow sub">Detail</span>
      <select id="graphics-quality" value={stored ?? 'auto'} disabled={fromAddress} onChange={(event) => {
        storeGraphics(event.target.value === 'auto' ? null : event.target.value as GraphicsQuality);
        location.reload();
      }} style={{ width: 210 }}>
        <option value="auto">Automatic ({QUALITY_LABEL[automaticGraphics()]})</option>
        <option value="low">Low: plain, fastest</option>
        <option value="balanced">Balanced: glow and grade</option>
        <option value="high">High: shading, reflections, soft smoke</option>
      </select>
    </label>
    <p className="sub" style={{ fontSize: 'var(--fs-sm)', marginTop: 6 }}>{fromAddress
      ? `Set to ${QUALITY_LABEL[graphicsProfile().name]} by this page's address.`
      : 'Changing it reloads the page.'}</p>
    <p className="sub" style={{ fontSize: 'var(--fs-sm)', marginTop: 6 }}>Low still shows damaged buildings and ruins; it reduces lighting effects and resolution.</p>
  </>;
}
